<div #modalRoot class="dtg-overlay" [style.display]="visible ? 'flex' : 'none'">
  <div class="dtg-card">
    <div class="dtg-icon-wrapper">
      <span class="dtg-icon">⚠️</span>
    </div>
    <h2 class="dtg-title">SECURITY VIOLATION!</h2>
    <div class="dtg-badge">UNUSUAL ACTIVITY DETECTED</div>
    <p class="dtg-text">{{ reason }}</p>
    <div class="dtg-consequence">
      💥 <span>Unusual activity detected on your account. Please try again later.</span>
    </div>
    <button class="dtg-btn" (click)="close()">RETURN TO LOBBY</button>
  </div>
</div>
